module.exports = __webpack_public_path__ + "img/2.76b5e664.jpg";